import React, { useEffect, useState  } from 'react';
import { useNavigate } from "react-router-dom";
import { Layout, Menu, Avatar, Button, Drawer } from "antd";
import {
	PlayCircleOutlined,
	MenuOutlined,
	FileImageOutlined,
	FileTextOutlined,
	AudioOutlined,
	BarChartOutlined,
	ReadOutlined,
} from "@ant-design/icons";
import { useLocation } from 'react-router-dom';
import constants from '../../../constants/constants';
import { getColorClass } from '../../../functions/functions';
import { COOKIE, getCookie } from '../../../services/cookie';
import { useContext } from "react";
import { Context } from "../../../Context";
const { Header } = Layout;
const StudentHeader = () => {
	const navigate = useNavigate();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const colorCode = constants.ColorCode;
	const menuItemClass ="flex items-center gap-3";
	const iconBoxClass =`w-7 h-7 min-w-[25px] min-h-[25px] flex items-center justify-center rounded text-base font-semibold shrink-0`;
	const labelClass =`flex-1 min-w-0 text-sm md:text-base leading-5 overflow-hidden whitespace-normal sm:overflow-visible`;
	let location = useLocation();
	const { user, chapterList } = useContext(Context);
	const [current, setCurrent] = useState("dashboard");
	const [openKeys, setOpenKeys] = useState([]);
	const handleMenuNavigation = (path, key, state=null) => {
		setCurrent(key);
		setMobileMenuOpen(false);
		navigate(path, { state });
	};
	useEffect(() => {
		const pathKey = location.pathname.substring(1); 
		// Handle specific nested route routing keys if necessary
		if (pathKey) {
			if(pathKey === "chapter-resources"){
				const chapterId = location?.state?.chapter_id;
				if(chapterId){
					setCurrent(`chapter-${chapterId}`);
				}
			}else{
				setCurrent(pathKey);
			}
		} else {
			setCurrent("dashboard");
		}
	}, [location.pathname]);
	const resourceMenu = [
		{
			key: "image-resources",
			icon: <div className={`${iconBoxClass} bg-purple-100`}>
				<FileImageOutlined aria-hidden="true"/>
			</div>,
			label: <span className={labelClass}>{constants.Images}</span>,
			onClick: () => handleMenuNavigation("image-resources", "image-resources"),
		},
		{
			key: "study-guide-resources",
			icon: <div className={`${iconBoxClass} bg-pink-100`}>
				<FileTextOutlined aria-hidden="true"/>
			</div>,
			label: <span className={labelClass}>{constants.StudyGuides}</span>,
			onClick: () => handleMenuNavigation("study-guide-resources", "study-guide-resources"),
		},
		{
			key: "video-resources",
			icon: <div className={`${iconBoxClass} bg-orange-200`}>
				<PlayCircleOutlined aria-hidden="true"/>
			</div>,
			label: <span className={labelClass}>{constants.Videos}</span>,
			onClick: () => handleMenuNavigation("video-resources", "video-resources"),
		},
		{
			key: "audio-resources",
			icon: <div className={`${iconBoxClass} bg-green-200`}>
				<AudioOutlined aria-hidden="true"/>
			</div>,
			label: <span className={labelClass}>{constants.Podcasts}</span>,
			onClick: () => handleMenuNavigation("audio-resources", "audio-resources"),
		},
		{
			key: "notes",
			icon: <div className={`${iconBoxClass} bg-yellow-200`}>
				<ReadOutlined aria-hidden="true"/>
			</div>,
			label: <span className={labelClass}>{constants.MyNotes}</span>,
			onClick: () => handleMenuNavigation("notes", "notes"),
		},
		{
			key: "compare-score",
			icon: <div className={`${iconBoxClass} bg-blue-100`}>
				<BarChartOutlined aria-hidden="true"/>
			</div>,
			label: <span className={labelClass}>{constants.TestScoreComparison}</span>,
			onClick: () => handleMenuNavigation("compare-score", "compare-score"),
		},
	];
	const getChapterList = () => {
		return chapterList.map((chapter, index) => {
			const state = {
				chapter_id: chapter?.chapter_id,
			};
			return {
				key: `chapter-${chapter?.chapter_id}`,
				label: (
					<div className={menuItemClass}>
						<div
							style={{
								backgroundColor:
									colorCode[index % colorCode.length],
							}}
							className={`${iconBoxClass} text-white`}
							aria-hidden="true"
						>
							{chapter?.chapter_id}
						</div>
						<div
							className={labelClass}
							title={chapter?.chapter_title}
							aria-label={chapter?.chapter_title}
						>
							{chapter?.chapter_title}
						</div>
					</div>
				),
				onClick: () =>
					handleMenuNavigation(
						"chapter-resources",
						`chapter-${chapter?.chapter_id}`,
						state
					),
			};
		});
	};
	const navItems = [
		{
			key: 'dashboard',
			label: "Home",
			onClick: () => handleMenuNavigation("/dashboard", "dashboard"),
		},
		{
			key: 'chapters',
			label: "Chapters",
			children: getChapterList(),
		},
		{
			key: 'resources',
			label: "Resources",
			children: resourceMenu,
		},
	];
	const onClick = e => {
		setCurrent(e.key);
	};
	const handleOpenChange = (keys) => {
		setOpenKeys(keys);
	};
	return (
		<>
			<div className={`absolute h-24 w-full z-0 opacity-75 bg-gradient-to-b ${getColorClass(location?.state?.chapter_id ? location?.state?.chapter_id : "1","gradientclass")}`}></div>
			<Header className="!leading-4 !bg-white mt-2 z-10 px-4 shadow-sm">
				<nav
					aria-label="Primary navigation"
					className="h-full container mx-auto"
				>
					<div className="flex items-center justify-between h-full">
						{/* LEFT SIDE */}
						<div className="flex flex-col">
							<h1 className="hidden lg:block text-xl roboto-slab font-normal">
								{constants.BookName}
							</h1>

							<div className="flex items-center gap-3 mt-1">
								<span className='block lg:hidden text-xl roboto-slab font-normal'>FAPSLH</span>
								<span className="text-rose-800 font-bold text-xs lg:text-base">
									{constants.Author}
								</span>
							</div>
						</div>

						{/* DESKTOP MENU */}
						<div className="hidden lg:flex items-center gap-4">
							<Menu
								mode="horizontal"
								items={navItems}
								className="border-none min-w-[280px] desktop-menu"
								onClick={onClick} selectedKeys={[current]}
								openKeys={openKeys}
								onOpenChange={handleOpenChange}
							/>
							{/* USER */}
							{
								process.env.REACT_APP_ENV === "qa" || process.env.REACT_APP_ENV === "dev" ?
									<>
										<Avatar aria-hidden="true" className='bg-rose-800 text-white'>U</Avatar>
										<span className='flex items-center'>Uma Thurman</span>
									</>
									: (
										<>
											<Avatar aria-hidden="true" className='bg-rose-800 text-white'>{user?.firstName ? user?.firstName?.substring(0, 1) : ""}</Avatar>
											<span className='flex items-center'>{user?.firstName ? user?.firstName + " " + user?.lastName : ""}</span>
										</>
									)
							}
						</div>
						{/* MOBILE MENU BUTTON */}
						<div className="lg:hidden flex items-center gap-3">
							{getCookie(COOKIE.FirstName) && (
								<Avatar className="bg-rose-800 text-white">
									{user?.firstName?.substring(0, 1)}
								</Avatar>
							)}

							<Button
								type="text"
								icon={<MenuOutlined aria-hidden="true"/>}
								onClick={() => setMobileMenuOpen(true)}
								aria-label="Open navigation menu"
							/>
						</div>
					</div>
				</nav>
			</Header>
			{/* MOBILE DRAWER */}
			<Drawer
				title="Menu"
				aria-labelledby="mobile-navigation-title"
				placement="right"
				onClose={() => setMobileMenuOpen(false)}
				open={mobileMenuOpen}
				width={320}
			>
				<Menu
					mode="inline"
					items={navItems}
					selectedKeys={[current]}
					className="border-none mobile-menu"
					style={{ borderInlineEnd: "none" }}
					openKeys={openKeys}
					onOpenChange={handleOpenChange}
				/>
			</Drawer>
		</>
	)
}

export default StudentHeader;